import { EntityTypeOld, ErrorStateOld } from "Store/interfaces/products";

import { Species } from "Store/interfaces/products/checkout/riskProducts/AnimalProduct";

export interface Breed {
  breed: string;
  breedRatingParameter: string;
}

export interface FindAnimalBreedData {
  readonly species: Species;
}

export type FindAnimalBreedEntity = EntityTypeOld<Breed[], OperationType>;
export type FindAnimalBreedError = ErrorStateOld<OperationType>;

export enum OperationType {
  FIND_ANIMAL_BREED = "FIND_ANIMAL_BREED",
}
